import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-model-collateral-edit-model',
  templateUrl: './ll-model-collateral-edit-model.component.html',
  styleUrl: './ll-model-collateral-edit-model.component.css'
})
export class LlModelCollateralEditModelComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_model_collateral_edit_model') mainDiv!: ElementRef;

  bundle = {
    showDisplay: false,
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 20,
    panelW: 0,
    panelH: 0,
    model: [] as any[],
  };

  private originalCommitmentAmt: string = ''; // stored without commas

  // ── Loan Commitment – formatted display (with commas) ──
  get formattedCommitmentAmt(): string {
    const raw = this.bundle.model?.[0]?.LIMIT_COMMITMENT_AMT || '';
    const num = parseInt(raw.replace(/[^0-9]/g, ''), 10);
    return isNaN(num) ? '' : num.toLocaleString('en-US');
  }

  updateCommitmentAmt(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^0-9,]/g, '');
    value = value.replace(/^,+/, '').replace(/,,+/g, ',');
    const cleanValue = value.replace(/,/g, '');
    if (this.bundle.model?.[0]) {
      this.bundle.model[0].LIMIT_COMMITMENT_AMT = cleanValue;
    }
    input.value = this.formattedCommitmentAmt;
  }

  get hasCommitmentChanged(): boolean {
    const current = this.bundle.model?.[0]?.LIMIT_COMMITMENT_AMT || '';
    return current !== this.originalCommitmentAmt;
  }

  saveCommitmentChange(): void {
    if (!this.hasCommitmentChanged) return;
    const newValue = this.bundle.model?.[0]?.LIMIT_COMMITMENT_AMT || '';
    this.saveFieldChange('LIMIT_COMMITMENT_AMT', newValue);
    this.originalCommitmentAmt = newValue;
  }

  // ── Options ──
  collateralTypeOptions = [
    { label: 'Month Close', value: 'Close' },
    { label: 'Daily', value: 'Daily' },
    { label: 'Average', value: 'Average' }
  ];

  trueUpTypeOptions = [
    { label: 'Posted Payments', value: 'PaymentsPosted' },
    { label: 'Eligible AR', value: 'Eligible' }
  ];

  trueUpIneligiblePayerTypeOptions = [
    { label: 'Exclude', value: 'Exclude' },
    { label: 'Include', value: 'Include' },
    { label: 'Include Separate-Remove', value: 'Separate_Remove' },
    { label: 'Include Separate-Add', value: 'Separate_Add' },
    { label: 'Include Separate-Add Back', value: 'Separate_AddBack' },
    { label: 'Include Alone-Debit', value: 'Alone_Remove' },
    { label: 'Include Alone-Credit', value: 'Alone_Add' },
  ];

  trueUpStartWhenOptions = [
    { label: 'First of Month', value: 'FirstofMonth'},
    { label: 'Month Close Date', value: 'CloseDate' }
  ];

  unpostedStartWhenOptions = [
    { label: 'First of Month', value: 'FirstofMonth' },
    { label: 'Month Close Date', value: 'CloseDate' },
    { label: 'BBC Data Through Date', value: 'ThroughDate' }
  ];

  bbcLocationOptions = [
    { label: 'Before Eligible AR', value: 'beforeEligible' },
    { label: 'After Available', value: 'afterAvailable' }
  ];

  ineligiblePayerDisplayTypeOptions = [
    { label: 'Inelig.Payer Total', value: 'Payer Total' },
    { label: 'Inelig.Payer GT/LT Age Cap', value: 'AgeCap' }
  ];

  calcSequenceOptions = [
    { label: 'Cross-Age then Credit', value: 'cross-credit' },
    { label: 'Credit then Cross-Age', value: 'credit-cross' }
  ];

  calcLevelOptions = [
    { label: 'Payer', value: 'payer' },
    { label: 'Location-Payer', value: 'locationPayer' }
    
  ];

  ageCapOptions = ['30', '60', '90', '120', '150', '180', '210'];

  includeCurrentArOptions = ['Yes', 'No'];

  envLowerRangeOptions = ['0', '-20', '-40', '-60', '-80', '-100'];

  envUpperRangeOptions = ['0', '20', '40', '60', '80', '100'];

  daysToBillOptions = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

  //crossAgePctOptions = ['30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90', '95', '100'];

  //percents = ['30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90', '95', '100'];

  crossAgePctOptions: string[] = Array.from({ length: 71 }, (_, i) => String(30 + i));

  // ── Getters ──
  get collateralType(): string {
    return this.bundle.model?.[0]?.LIMIT_COLLATERAL_TYPE || '';
  }

  get ageCapCalcLevel(): string {
    return this.bundle.model?.[0]?.LIMIT_AGECAP_CALCLEVEL || '';
  }


  get calcSequence(): string {
    return this.bundle.model?.[0]?.LIMIT_CALCSEQUENCE || '';
  }
  get customClassBBCYesNo(): string {
    return this.bundle.model?.[0]?.CUSTOMCLASSBBCYESNO || '';
  }
  get trueUpBbcYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPBBCYESNO || '';
  }

  get trueUpBBCLocation(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPBBCLOCATION || '';
  }


  get trueUpType(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPTYPE || '';
  }

  get trueUpIneligiblePayerType(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPINELIGIBLEPAYERTYPE || '';
  }

  get trueUpIneligiblePayersYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPINELIGIBLEPAYERSYESNO || '';
  }

  get trueUpStartWhen(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPSTARTWHEN || '';
  }

  get showTrueUpBbcField(): boolean {
    return (this.collateralType || '').toLowerCase() === 'close';
  }

  get bbcLocation(): string {
    return this.bundle.model?.[0]?.LIMIT_TRUEUPBBCLOCATION || '';
  }

  get showBbcLocationField(): boolean {
    return this.trueUpBbcYesNo === 'Yes';
  }

  get billedAgeCapDays(): string {
    return this.bundle.model?.[0]?.LIMIT_BILLED_AGECAPDAYS || '';
  }

  get unbilledAgeCapDays(): string {
    return this.bundle.model?.[0]?.LIMIT_UNBILLED_AGECAPDAYS || '';
  }

  get daysToBill(): string {
    return this.bundle.model?.[0]?.LIMIT_DAYSTOBILL || '';
  }

  get billedAdvancePct(): string {
    return this.bundle.model?.[0]?.LIMIT_BILLEDADVANCE_PCT || '';
  }

  get unbilledAdvancePct(): string {
    return this.bundle.model?.[0]?.LIMIT_UNBILLEDADVANCE_PCT || '';
  }

  get currentIncludedYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_CURRENTINCLUDEDYESNO || '';
  }

  get currentEarnedYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_CURRENTEARNEDYESNO || '';
  }

  get currentBbcLocation(): string {
    return this.bundle.model?.[0]?.LIMIT_CURRENT_BBCLOCATION || '';
  }

  get unpostedIncludeYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_UNPOSTED_INCLUDEYESNO || '';
  }

  get unpostedStartWhen(): string {
    return this.bundle.model?.[0]?.LIMIT_UNPOSTED_STARTWHEN || '';
  }

  get unpostedBbcLocation(): string {
    return this.bundle.model?.[0]?.LIMIT_UNPOSTED_BBCLOCATION || '';
  }

  get unpostedAgeCapDays(): string {
    return this.bundle.model?.[0]?.LIMIT_UNPOSTED_AGECAPDAYS || '';
  }

  get unpostedIneligiblePayersYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_UNPOSTED_INELIGIBLEPAYERSYESNO || '';
  }

  get unpostedUserCanEditYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_UNPOSTED_USERCANEDITYESNO || '';
  }

  get envDynamicYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_ENV_DYNAMICYESNO || '';
  }

  get envOverridePct(): string {
    return this.bundle.model?.[0]?.LIMIT_ENV_OVERRIDE_PCT || '';
  }

  get envCalcPeriodDays(): string {
    return this.bundle.model?.[0]?.LIMIT_ENV_CALCPERIOD_DAYS || '';
  }

  get envLowerRange(): string {
    return this.bundle.model?.[0]?.LIMIT_ENV_LOWERRANGE || '';
  }

  get envUpperRange(): string {
    return this.bundle.model?.[0]?.LIMIT_ENV_UPPERRANGE || '';
  }

  get creditsYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_CREDITS_YESNO || '';
  }

  get creditsCalcLevel(): string {
    return this.bundle.model?.[0]?.LIMIT_CREDIT_CALCLEVEL || '';
  }

  get creditsDays(): string {
    return this.bundle.model?.[0]?.LIMIT_CREDITS_DAYS || '';
  }

  get crossAgeYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_CROSSAGE_YESNO || '';
  }

  get crossAgeCalcLevel(): string {
    return this.bundle.model?.[0]?.LIMIT_CROSSAGE_CALCLEVEL || '';
  }


  get crossAgeDays(): string {
    return this.bundle.model?.[0]?.LIMIT_CROSSAGE_DAYS || '';
  }

  get crossAgePct(): string {
    return this.bundle.model?.[0]?.LIMIT_CROSSAGE_PCT || '';
  }

  get payerCapYesNo(): string {
    return this.bundle.model?.[0]?.LIMIT_PAYERCAP_YESNO || '';
  }

  get payerCapPct(): string {
    return this.bundle.model?.[0]?.LIMIT_PAYERCAP_PCT || '';
  }

  // ── Centralized save method ──
  private saveFieldChange(fieldName: string, newValue: string): void {
    this.LlModelsService.NG_LL_company_model_edit(fieldName, newValue);
    console.log(`Saved field ${fieldName} = ${newValue}`);
  }

  // ── Dynamic setter ──
  setModelValue(fieldName: string, value: string): void {
    if (this.bundle.model?.[0]) {
      this.bundle.model[0][fieldName] = value;
    }
  }

  // ── Single change handler for all fields ──
  onChanged(fieldName: string, newValue: string): void {
    this.setModelValue(fieldName, newValue);
    this.saveFieldChange(fieldName, newValue);
  }

  constructor(private LlModelsService: LlModelsService) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.setVars();
  }

  ngOnDestroy(): void { }

  setVars() {
    if (!this.mainDiv?.nativeElement?.parentElement?.parentElement) return;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY;
      this.getData();
    }, 0);
  }

  getData() {
    this.LlModelsService.NG_LL_company_model_get((arr: any[]) => {
      console.log('Model data loaded:', arr);
      this.bundle.model = arr || [];
      this.originalCommitmentAmt = this.bundle.model?.[0]?.LIMIT_COMMITMENT_AMT || '';
      this.bundle.showDisplay = true;
    });
  }
}
